import React from 'react';

const styles = {
  paperStyle: {
    display: 'flex',
    flexDirection: 'row',
    padding: '20px',
    justifyContent: 'space-around',
  },
  columnStyle: {
    display: 'flex',
    flexDirection: 'column',
  },
  marginStyle: {
    display: 'flex',
    flexDirection: 'row',
    marginLeft: '60px',
    marginRight: '60px',
  },
  contentContainerBlock: {
    position: 'relative',
    padding: '22px',
    display: 'flex',
    justifyContent: 'center',
  },
};

export const Row = ({ children }) => (
  <div style={styles.paperStyle}>{children}</div>
);

export const Column = ({ children }) => (
  <div style={styles.columnStyle}>{children}</div>
);

export const Margin = ({ children }) => (
  <div style={styles.marginStyle}>{children}</div>
);

export const Content = ({ children }) => (
  <div className="content-container-block" style={styles.contentContainerBlock}>
    {children}
  </div>
);



// WEBPACK FOOTER //
// ./src/components/commons/Containers.js